<template>
    <figure :class="['image', ratio, { 'is-center': isCenter }]" :style="{ maxWidth: width + 'px', maxHeight: height + 'px' }">
        <circles-loader v-if="isLoading" :bg="false" :parent="$el" color="#ddd" width="64px" height="64px" />
    </figure>
</template>

<script>
import CirclesLoader from './loaders/circles-loader'
import CryptoJS from 'crypto-js'

export default {
    name: 'AppImage',
    components: {
        CirclesLoader
    },
    props: {
        isCover: {
            type: Boolean,
            default: false
        },
        ratio: {
            type: String,
            default: '', // is-4by3
        },
        has: {
            type: [String, Number],
            default: '',
        },
        token: {
            type: [String, Number],
            default: '',
        },
        type: {
            type: [String, Number],
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: '',
        },
        svrUrl: {
            type: String,
            default: process.env.VUE_APP_API_URL + `/media/resize-image`,
        },
        width: {
            type: Number,
            default: null,
        },
        height: {
            type: Number,
            default: null,
        },
        isCenter: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        isLoading: false,
        decodeInfoUser: '',
        key: 'decodeImage123@321',
    }),
    watch: {
        has: function (vl) {
            this.getImageData();
        },
        url: function (vl) {
            this.getImageData();
        },
        token: function (vl) {
            this.getImageData();
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.getImageData();
        });
    },
    methods: {
        decodeInfo() {
            this.decodeInfoUser = CryptoJS.AES.decrypt(this.token, this.key).toString(CryptoJS.enc.Utf8)
        },
        getImageData() {
            const defaultImg = require('@/assets/img/picture.svg');
            const image = new Image();
            image.alt = this.title;
            const el = this.$el;
            const that = this;

            image.onload = function () {
                if (el.querySelector('img')) el.querySelector('img').remove();

                el.appendChild(image);
                that.isLoading = false;
            };

            image.onerror = function (e) {
                image.src = defaultImg;
                that.isLoading = false;
            };

            if (this.url && !this.has) {
                this.isLoading = true;
                image.src = this.url;
            } else if (this.has) {
                this.isLoading = true;
                const url = new URL(this.svrUrl);

                // media/resize-imageにクエリパラメータを渡す
                const query_string = url.searchParams;
                query_string.append('has', this.has);
                query_string.append('type', this.type);
                query_string.append('token', this.token);

                if (this.size) query_string.append('s', this.size);
                image.src = decodeURIComponent(url.toString());
            }
        },
    },
};
</script>

<style lang="scss">
.is-cover {
    object-fit: cover;
}

.is-center {
    img {
        margin: auto;
        width: auto !important;
    }
}

.ajax-loader {
    height: 40px;
}
</style>
